import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'

export default function TutorialCard({ icon, title, tutorials, showTutorial}) {
  const iconStyle = {
    width: '25px',
    height: '25px', 
    display: 'flex', 
    alignItems: 'center', 
    background: '#1ab2e9', 
    borderRadius: '100%', 
    justifyContent: 'center', 
  }

  const titleStyle = {
    color: '#1ab2e9',
    fontWeight: 500
  }

  return (
    <Card className='border-0 axs-rounded axs-shadow h-100'>
      <Card.Body>
        <Row>
          <Col xs='1'>
            <div style={iconStyle}>
              <small>
                { icon }
              </small>
            </div>
          </Col>
          <Col>
            <Row>
              <Col style={titleStyle}>{ title }</Col>
            </Row>
            {
              tutorials.map((tutorial, index) => {
                return <div key={index} onClick={() => showTutorial(tutorial)} className='tutorial font-weight-light mt-2 cursor-pointer'>
                  <i className='fas fa-angle-right pr-2'></i>{ tutorial.title }
                </div>
              })
            }
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
